import { StylesProvider, withStyles, WithStyles } from '@material-ui/core/styles'
import createStyles from '@material-ui/core/styles/createStyles'
import CloseButton from '@material-ui/icons/Close'
import MapboxGl from 'mapbox-gl'
import React, { useContext, useEffect } from 'react'
import { createRoot } from 'react-dom/client'

import { muiV4GenerateClassName } from 'src/commons/muiV4Styles'

import { MapContext } from './index'

const styles = () =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    closeButton: {
      alignSelf: 'end',
      height: '20px',
      marginBottom: '-20px',
      zIndex: 2, // above the Mapbox layers so we can click on the close button
      fontSize: 18,
      cursor: 'pointer',
    },
  })

interface IProps extends WithStyles<typeof styles> {
  children: React.ReactNode
  closeButton?: boolean
  coordinates: MapboxGl.LngLat
  horizontalOffset?: number
  verticalOffset?: number
}
const MapPopup = ({
  classes,
  children,
  coordinates,
  horizontalOffset = 0,
  verticalOffset = 0,
  closeButton = true,
}: IProps) => {
  let popUp: MapboxGl.Popup | undefined = undefined
  const map = useContext(MapContext)

  const onCloseClick = () => {
    if (popUp && popUp.isOpen()) {
      popUp.remove()
    }
  }

  const renderCloseButton = () => {
    return <CloseButton className={classes.closeButton} onClick={onCloseClick} />
  }

  useEffect(() => {
    if (map) {
      const content = document.createElement('div')
      const root = createRoot(content)
      // Mapbox owns this node, so it is its own React root and no provider from 'main' reaches it.
      root.render(
        <StylesProvider generateClassName={muiV4GenerateClassName}>
          <div className={classes.root}>
            {closeButton && renderCloseButton()}
            {children}
          </div>
        </StylesProvider>
      )
      popUp = new MapboxGl.Popup({
        maxWidth: 'none',
        closeButton: false,
        offset: [horizontalOffset, verticalOffset],
      })
        .setLngLat(coordinates)
        .setDOMContent(content)
        .addTo(map)
    }

    // Before we create a new MapboxGl.Popup instance, we need to remove it if any.
    return () => {
      if (popUp) {
        popUp.remove()
      }
    }
  }, [coordinates])
  return null
}

export default withStyles(styles)(MapPopup)
